<template>
  <div class="connection-modal" ref="connectionModal">
    <a-modal
      v-model:open="configs.waitingOpen"
      :closable="false"
      :width="720"
      :getContainer="() => connectionModal"
      :destroyOnClose="true"
      :maskClosable="false"
      :footer="null"
    >
      <div class="content">
        <div class="loading">
          <a-spin size="large" />
          <p>{{ st('settingsConnectionModal.waitingPlease') }}<br />{{ st('settingsConnectionModal.waitingSeconds') }}</p>
        </div>
        <p class="note">{{ st('settingsConnectionModal.waitingNotice') }}</p>
        <div class="qrcodes-modal-wrapper" ref="qrcodes">
          <div class="qrcodes">
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../../assets/images/social-media-qrcode/slack.png" :alt="st('settingsConnectionModal.imgAltSlackQr')" />
                <p>{{ st('settingsConnectionModal.scanQrCode') }}</p>
              </template>
              <svg class="icon slack" aria-hidden="true" style="fill: #fff">
                <use xlink:href="#icon-slack" />
              </svg>
            </a-popover>
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../../assets/images/social-media-qrcode/whatsapp.png" :alt="st('settingsConnectionModal.imgAltWhatsappQr')" />
                <p>{{ st('settingsConnectionModal.scanQrCode') }}</p>
              </template>
              <i class="iconfont icon-whatsapp" />
            </a-popover>
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../../assets/images/social-media-qrcode/wechat.png" :alt="st('settingsConnectionModal.imgAltWechatQr')" />
                <p>{{ st('settingsConnectionModal.scanQrCode') }}</p>
              </template>
              <i class="iconfont icon-wechat" />
            </a-popover>
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                <img src="../../../../assets/images/social-media-qrcode/lark.png" :alt="st('settingsConnectionModal.imgAltLarkQr')" />
                <p>{{ st('settingsConnectionModal.scanQrCode') }}</p>
              </template>
              <svg class="icon lark" aria-hidden="true" style="fill: #fff">
                <use xlink:href="#icon-lark" />
              </svg>
            </a-popover>
          </div>
        </div>
      </div>
      <template #title>
        <div class="modal-title">{{ st('settingsConnectionModal.connectingTitle') }}</div>
      </template>
    </a-modal>
    <artmisads-modal
      v-model:open="configs.failedOpen"
      :width="600"
      :getContainer="() => connectionModal"
      :footer="null"
    >
      <div class="fail-content">
        <div v-if="configs.errorCode=='2010'">
          <div>{{ st('settingsConnectionModal.failedDuplicateAccount') }}</div>
          <div>{{ st('settingsConnectionModal.failedEmailIntroDuplicate') }}</div>
        </div>
        <div v-else>
          <div>{{ st('settingsConnectionModal.failedGeneric') }}</div>
          <div>{{ st('settingsConnectionModal.failedEmailIntroGeneric') }}</div>
        </div>
        <div>
          <a class="email">Support@ArtemisAds.com</a>
        </div>
      </div>
      <template #title>
        <div class="modal-title">{{ st('settingsConnectionModal.failedTitle') }}</div>
      </template>
    </artmisads-modal>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
const { configs } = defineProps(["configs"]);
const connectionModal = ref();
</script>
<style lang="less" scoped>
.connection-modal {
  .modal-title {
    font-size: 32px;
    text-align: center;
  }
  .content {
    width: 100%;
    display: flex;
    border-radius: 8px;
    align-items: center;
    flex-direction: column;
    background: var(--color-white);

    .loading {
      width: 100%;
      padding: 72px 0;
      text-align: center;
      border-radius: 8px;
      background-color: #f8f7fc;

      >p {
        height: 40px;
        margin-top: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        color: var(--dark-2);
        letter-spacing: 0.4px;
      }
    }

    .note {
      width: 100%;
      height: 20px;
      font-size: 13px;
      margin-top: 24px;
      margin-bottom: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
    }
  }
  .fail-content{
    .email{
      margin-bottom: 24px;
      text-decoration: underline;
      color: var(--dark-2);
      font-weight: 500;
      &:hover{
        color: var(--dark-1);
      }
    }
  }
  .qrcodes-modal-wrapper {
    width: 100%;

    img {
      width: 112px;
    }

    :deep(.ant-popover-inner) {
      padding: 10px;

      &-content>p {
        height: 16px;
        font-size: 11px;
        margin-top: 7px;
        line-height: 16px;
        text-align: center;
        color: var(--dark-4);
        letter-spacing: 0.28px;
      }
    }
  }

  .qrcodes {
    gap: 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon,
    .iconfont {
      width: 32px;
      height: 32px;
      padding: 4px;
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #E8E5ED;
    }

    .iconfont {
      color: #fff;
      font-size: 24px;
      font-weight: normal;
      background-color: #25D366;

      &::before {
        display: block;
        margin-top: -7px;
        margin-left: -1px;
      }
    }
  }
}
</style>
